<template>
    <div class="review">
        <BaseHeader></BaseHeader>
        <div class="divCount">
            <div class="divmain">
                <div class="divLeft">
                    <span style=" margin-top: 20px;">作品评审</span>
                </div>
                <div class="divReight">
                    <el-table :data="tableData" height="250" style="width: 100%">
                        <el-table-column type="index" width="50" />
                        <el-table-column prop="学校名称" label="Date" width="180" />
                        <el-table-column prop="项目名称" label="Name" width="180" />
                        <el-table-column prop="操作" label="Address" />
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BaseHeader from '../../views/base/BaseHeader.vue';
import { GetMatchList } from '../../http/match';
import { GetJudgesReformSubmit } from '../../http/submit';
import { ElMessage } from "element-plus";
export default {
    mounted() {
        this.FormGetJudgesReformSubmit();
    }, data() {
        return {
            tableData: [],
            data: [],
        }
    }, methods: {
        getMatchList() {
            GetMatchList({}).then((res) => {
                if (res.IsSuccess) {
                    this.data = res.Models;
                } else {
                    ElMessage.error(res.ErrorMessage);
                }
            });
        },
        FormGetJudgesReformSubmit() {
            GetJudgesReformSubmit().then((res) => {
                if (res.IsSuccess) {
                    this.tableData = res.Models;
                } else {
                    ElMessage.error(res.ErrorMessage);
                }
            });
        }

    }, components: {
        BaseHeader
    },

};
</script>
<style scoped>
body {
    width: 100vw;
    height: 100vw;
}

.review {
    width: 100vw;
    height: 100vh;
}

.divCount {
    height: calc(100% - 88px);
    width: 100%;
    background-color: #f5f5f5;

}

.divmain {
    height: 100%;
    width: 80%;
    margin: 0 auto;
    background-color: white;
}

.divLeft {
    float: left;
    width: 20%;
    height: 100%;
    text-align: center;
    background-color: #e4e4e7;
}

.divReight {
    float: left;
    width: 80%;
}
</style>
